export class ValidationEbook {
	constructor() {
		this.patterns = {
			twodots: /\.{2,}/,
			mail: /^[\da-z][\w_.]+[\da-z]@[\w-.]+\.[a-z]{2}$/,
			phone: /^\d+$/
		};
	}
	checkMail (string) {
		return this.patterns.mail.test(string) && this.patterns.twodots.test(string) && string.length > 5;
	}
	checkPhone (string) {
		return this.patterns.phone.test(string) && string.length > 8;
	}
}
